<form class="g-slider-container">
  <div class="g-field-area">
    <label class="g-mandatory" for="licenseCodeInputName">{{ dialogTexts.field }}</label>

    <input type="text"
           [placeholder]="dialogTexts.field"
           id="licenseCodeInputName"
           class="g-medium-field"
           autocomplete="off"
           [formControl]="code"/>

    <app-validation-message [messageText]="dialogTexts.required" [validation]="formValidatorsService.isEmpty(code)"></app-validation-message>
    <app-validation-message [messageText]="dialogTexts.invalid" [validation]="formValidatorsService.isBadPattern(code)"></app-validation-message>
  </div>
</form>
